import { indexTopics } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-accent-500/15 text-accent-400 border border-accent-500/20 mb-4">
            内容导航
          </span>
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-50">
            热门专题
          </h2>
          <p className="mt-3 text-sm text-foreground-400 max-w-lg mx-auto">
            精选七大内容板块，快速找到你感兴趣的黑料视频与吃瓜资讯
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {indexTopics.slice(0, 4).map((item) => (
            <a
              key={item.id}
              href="#media"
              className="group block p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/50 hover:border-primary-500/30 transition-all duration-300 cursor-pointer"
            >
              <div className="flex items-start justify-between mb-3">
                <div className="w-11 h-11 rounded-lg bg-primary-500/10 flex items-center justify-center">
                  <i className={`${item.icon} text-xl text-primary-400`}></i>
                </div>
                <span className={`px-2 py-0.5 text-[11px] font-medium rounded-full whitespace-nowrap ${
                  item.tag === '爆' ? 'bg-primary-500/20 text-primary-400' :
                  item.tag === '热' ? 'bg-accent-500/20 text-accent-400' :
                  item.tag === '新' ? 'bg-secondary-500/20 text-secondary-300' :
                  'bg-background-200/50 text-foreground-400'
                }`}>
                  {item.tag}
                </span>
              </div>
              <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-100 group-hover:text-primary-400 transition-colors mb-2">
                {item.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed mb-3">
                {item.desc}
              </p>
              <span className="text-xs text-foreground-600">
                <i className="ri-eye-line mr-1"></i>{item.count} 浏览
              </span>
            </a>
          ))}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5 mt-4">
          {indexTopics.slice(4).map((item) => (
            <a
              key={item.id}
              href="#media"
              className="group block p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/50 hover:border-primary-500/30 transition-all duration-300 cursor-pointer"
            >
              <div className="flex items-start justify-between mb-3">
                <div className="w-11 h-11 rounded-lg bg-primary-500/10 flex items-center justify-center">
                  <i className={`${item.icon} text-xl text-primary-400`}></i>
                </div>
                <span className={`px-2 py-0.5 text-[11px] font-medium rounded-full whitespace-nowrap ${
                  item.tag === '爆' ? 'bg-primary-500/20 text-primary-400' :
                  item.tag === '热' ? 'bg-accent-500/20 text-accent-400' :
                  item.tag === '新' ? 'bg-secondary-500/20 text-secondary-300' :
                  'bg-background-200/50 text-foreground-400'
                }`}>
                  {item.tag}
                </span>
              </div>
              <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-100 group-hover:text-primary-400 transition-colors mb-2">
                {item.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed mb-3">
                {item.desc}
              </p>
              <span className="text-xs text-foreground-600">
                <i className="ri-eye-line mr-1"></i>{item.count} 浏览
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}